var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v("Statistik Harian")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Statistik Harian")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "row filter-row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group row" }, [
                      _c("label", { staticClass: "col-form-label col-md-4" }, [
                        _vm._v("Brand")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-8" },
                        [
                          _c(
                            "multiselect",
                            {
                              attrs: {
                                id: "ajax",
                                label: "license_name",
                                "track-by": "id",
                                placeholder: "Type to search Brand...",
                                multiple: true,
                                "open-direction": "bottom",
                                "custom-label": _vm.customLabel,
                                options: _vm.contactOptions,
                                searchable: true,
                                loading: _vm.isLoading,
                                "internal-search": false,
                                "close-on-select": false,
                                "options-limit": 300,
                                limit: 3,
                                "limit-text": _vm.limitText,
                                "max-height": 600,
                                "show-no-results": true,
                                "hide-selected": true,
                                "show-labels": false
                              },
                              on: { "search-change": _vm.asyncFind },
                              scopedSlots: _vm._u([
                                {
                                  key: "tag",
                                  fn: function(ref) {
                                    var option = ref.option
                                    var remove = ref.remove
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "custom__tag" },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(option.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "custom__remove",
                                              on: {
                                                click: function($event) {
                                                  return remove(option)
                                                }
                                              }
                                            },
                                            [_vm._v("❌")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "clear",
                                  fn: function(props) {
                                    return [
                                      _vm.selectedContact.length
                                        ? _c("div", {
                                            staticClass: "multiselect__clear",
                                            on: {
                                              mousedown: function($event) {
                                                $event.preventDefault()
                                                $event.stopPropagation()
                                                return _vm.clearAll(
                                                  props.search
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.selectedContact,
                                callback: function($$v) {
                                  _vm.selectedContact = $$v
                                },
                                expression: "selectedContact"
                              }
                            },
                            [
                              _vm._v(" "),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  attrs: { slot: "noResult" },
                                  slot: "noResult"
                                },
                                [_vm._v("Oops! No elements found.")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group form-focus" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formDataReport.date,
                            expression: "formDataReport.date"
                          }
                        ],
                        staticClass: "form-control floating",
                        attrs: { type: "date" },
                        domProps: { value: _vm.formDataReport.date },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.formDataReport,
                              "date",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "focus-label sr-only" }, [
                        _vm._v("Tanggal")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("div", { staticClass: "form-group form-focus" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-success btn-block",
                          attrs: {
                            href: "#",
                            "data-toggle": "modal",
                            "data-target":
                              _vm.formDataReport.brand_id != "" &&
                              _vm.formDataReport.date != "" &&
                              "#report_form"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showReportForm($event)
                            }
                          }
                        },
                        [_vm._v("Submit")]
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "32px" } },
              [
                _vm._v(
                  "\n          Silakan pilih Brand dan Tanggal untuk melihat laporan.\n        "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("report")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ee74d1b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee74d1b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/monitoring/summary/reportAgent.vue
// module id = null
// module chunks = 